import { render, staticRenderFns } from "./KCPCertRequest.vue?vue&type=template&id=5a3e9570&"
import script from "./KCPCertRequest.vue?vue&type=script&lang=js&"
export * from "./KCPCertRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports